"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BackgroundMusic;

var _react = _interopRequireWildcard(require("react"));

var _reactSound = _interopRequireDefault(require("react-sound"));

var _assets = require("../../../assets");

var _EBackgroundMusicSong = _interopRequireDefault(require("./EBackgroundMusicSong"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getRandomGapDuration() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15000;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40000;
  return Math.floor(Math.random() * (+min - +max)) + +max;
}

function BackgroundMusic(_ref) {
  var _ref$song = _ref.song,
      song = _ref$song === void 0 ? _EBackgroundMusicSong.default.THE_CASTLE : _ref$song,
      _ref$volume = _ref.volume,
      volume = _ref$volume === void 0 ? 100 : _ref$volume,
      _ref$withRandomGap = _ref.withRandomGap,
      withRandomGap = _ref$withRandomGap === void 0 ? true : _ref$withRandomGap;

  var _useState = (0, _react.useState)("PLAYING"),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      pos = _useState4[0],
      setPos = _useState4[1];

  var src = "".concat(_assets.ASSETS_MUSIC, "/").concat(song);
  var onFinishedPlaying = (0, _react.useCallback)(function () {
    var gapDuration = withRandomGap ? getRandomGapDuration() : 0;
    setTimeout(function () {
      setStatus("STOPPED");
      setPos(0);
      setStatus("PLAYING");
    }, gapDuration); // TODO: clear timeout
  }, [withRandomGap]);
  return /*#__PURE__*/_react.default.createElement(_reactSound.default, {
    url: src,
    position: pos,
    volume: volume,
    playStatus: status,
    onFinishedPlaying: onFinishedPlaying
  });
}